import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
// import moment from 'moment';

interface IngredientsManagerState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    meta: any;
}

const state: IngredientsManagerState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    meta: null,
};

export const ITEMS_LIST = 'GET_CITY_LIST';
export const GET_SCHEMA = 'GET_SCHEMA';

export const actions: ActionTree<IngredientsManagerState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "id": "voc_ingredients.id",
                "name": "voc_ingredients.name",
                "code": "voc_ingredients.code",
                "code_1c": "voc_ingredients.code_1c",
                "type": "voc_ingredients.type",
                "archived_at": "voc_ingredients.archived_at",
                "archived_user_name": "e.name",
                "created_at": "voc_ingredients.created_at",
            };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["voc_ingredients.name", {"$": `%${query.name}%`}] })
            }
            const orders: any[] = [];

            if (query.sortFields) {
                JSON.parse((query.sortFields)).map((item: any) => {
                    orders.push(item.order == 'desc' ? { $desc: [columns[item.field || 'name' ]] } : { $asc: [columns[item.field || 'name']] })
                })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:voc_ingredients",
                    "from_as": "voc_ingredients",
                    joins: [
                        {
                            join: 's:employees',
                            as: 'e',
                            type: 'left',
                            on: {
                                $eq: ['voc_ingredients.archived_user_id', 'e.id']
                            }
                        }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: orders
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                }),
                vm.$q(GET_SCHEMA)
                .raw('schemas.get')
                .action({
                    id: `s:voc_ingredients`
                }),
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('SET_SCHEMA', result.getOperation(GET_SCHEMA).getContent().schema);
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    saveTodoType({ commit, getters, dispatch }, data) {
        const vm = (this as any)._vm;

        const query = data.id ?
            vm.$q('SAVE_DOCUMENT').update(data.id, data) :
            vm.$q('SAVE_DOCUMENT').create('voc_ingredients', data);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_DOCUMENT');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

};

export const mutations: MutationTree<IngredientsManagerState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
    SET_SCHEMA(state, schema) {
        state.meta = fetchEnumsFromSchema(schema);
    },
};

const getters = {

};

export const STORE_KEY = '$_ingredients_manger';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
